// @ts-nocheck
import { motion } from 'framer-motion';
import { YStack, XStack, Text } from 'tamagui';
import { Container } from './Container';
import { useIsMobile } from '../hooks/useIsMobile';

const MotionDiv = motion.div;

/**
 * The credibility strip directly below the hero.
 *
 * Single-product competitors fill this slot with customer logos. A portfolio
 * fills it with the portfolio — equally true, and it answers "what is this
 * company" before the visitor has to scroll.
 *
 * Set as a carved frieze: uppercase, wide-tracked, separated by interpuncts the
 * way Roman inscriptions separated words. That detail is why this reads as ours
 * rather than as a generic logo row.
 */
const names = [
  'Torch',
  'Statio',
  'Denarius',
  'JanusLedger',
  'Pilum',
  'Scuta',
  'Capsa',
  'Vigil',
];

export function PortfolioFrieze() {
  const isMobile = useIsMobile();

  return (
    <YStack
      paddingVertical={0}
    >
      <Container borderTopWidth={1} borderColor="$color3" paddingVertical={isMobile ? '$7' : '$9'}>
        <MotionDiv
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.5 }}
        >
          <YStack gap={isMobile ? '$4' : '$5'} alignItems="center">
            <Text
              fontSize="$2"
              color="$color7"
              letterSpacing={1.6}
              textTransform="uppercase"
              textAlign="center"
            >
              Eight products, one platform
            </Text>

            <XStack
              flexWrap="wrap"
              justifyContent="center"
              alignItems="baseline"
              columnGap={isMobile ? '$2' : '$4'}
              rowGap={isMobile ? '$2' : '$3'}
            >
              {names.map((name, i) => (
                <XStack key={name} alignItems="baseline" gap={isMobile ? '$2' : '$4'}>
                  <Text
                    fontSize={isMobile ? 14 : 19}
                    fontWeight="600"
                    color="$color11"
                    letterSpacing={isMobile ? 1.5 : 2.4}
                    textTransform="uppercase"
                    hoverStyle={{ color: '$color12' }}
                  >
                    {name}
                  </Text>
                  {i < names.length - 1 && (
                    <Text fontSize={isMobile ? 13 : 18} color="$amber9">
                      ·
                    </Text>
                  )}
                </XStack>
              ))}
            </XStack>
          </YStack>
        </MotionDiv>
      </Container>
    </YStack>
  );
}
